var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFalhaPagamento(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 77,
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.9991,
    cy: 38.3253,
    r: 38.3253,
    fill: "#D12600"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7335 47.3144H37.4399L35.9953 17.6718H42.1781L40.7335 47.3144ZM35.4753 55.8084C35.4753 54.3831 35.822 53.3816 36.5154 52.8037C37.2088 52.2259 38.0562 51.937 39.0578 51.937C40.0208 51.937 40.8491 52.2259 41.5425 52.8037C42.2744 53.3816 42.6403 54.3831 42.6403 55.8084C42.6403 57.1952 42.2744 58.1968 41.5425 58.8131C40.8491 59.4295 40.0208 59.7377 39.0578 59.7377C38.0562 59.7377 37.2088 59.4295 36.5154 58.8131C35.822 58.1968 35.4753 57.1952 35.4753 55.8084Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalhaPagamento);
export default __webpack_public_path__ + "static/media/falha_pagamento.b19b3f000e6e5875df92d52bb6af4c4f.svg";
export { ForwardRef as ReactComponent };